import { path } from 'ramda';

import { FEATURE_NAME as $, MAIN, APP } from './consts';

export const getErrors = path([$]);
export const getErrorsByType = (type) => path([$, type]);
export const getIsExistError = (state) => Boolean(path([$, MAIN], state), path([$, APP], state));
